import React from 'react';

export class PanelGroup extends React.Component{

    render(){
        const { title, children, id, show } = this.props;
        const panelID = id || 'id-2' + Math.floor(Math.random(0, 1)* 100);

        return(
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h4 className="panel-title">
                        <a data-toggle="collapse" href={ '#' + panelID }>
                            { title }
                        </a>
                    </h4>
                </div>
                <div 
                    id={ panelID } 
                    className={ 'panel-collapse collapse' + (show === true ? ' in' : '') }>
                    
                    <div className="panel-body">{ children }</div>
                </div>
            </div>
        );
    }
}

export class Accordion extends React.Component {

    render(){
        const { className } = this.props;

        return(
            <div className={ 'panel-group accordion ' + (className ? className : '') }>
            { this.props.children }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Accordion.jsx